import { Component, OnInit } from '@angular/core';
import { ContentService } from '../../shared/content.service';

@Component({
  selector: 'app-stx',
  templateUrl: './stx.component.html',
  styleUrls: ['./stx.component.scss']
})
export class StxComponent implements OnInit {
  page: Object;

  constructor(private contentService: ContentService) {
  }

  ngOnInit() {
    this.page = this.contentService.pages['stx'];
  }

}
